import { React, connect, withRouter } from '@gasbuddy/react';
import { Dimmer, Loader, Segment, Dropdown, Input, Button, TextArea, Grid, Form, Message } from 'semantic-ui-react';
import { Role } from '../../roles';
import { Auth, Nav } from '../../components';
import { fetch } from '../../../client/lib/fetch';

class BaseNotificationPage extends React.Component {
  state = {
    sender: 'gbpay',
    esp: 'et',
  }

  setStateField(field) {
    return (_, { value }) => {
      const stateChange = { [field]: value };
      this.setState(stateChange);
    };
  }

  callApi = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, async () => {
      const { esp, sender, fields, id } = this.state;
      try {
        const { status } = await fetch('/system/notifications', { sender, esp, fields: JSON.parse(fields || '{}'), id });
        this.setState({
          loading: false,
          status,
        });
      } catch (error) {
        this.setState({
          error: error.message,
          loading: false,
          status: 500,
        });
      }
    });
  }

  getTransactionId = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, async () => {
      const { transactionId } = this.state;
      try {
        const { status, body } = await fetch('/system/notifications/transaction-fields', { transactionId });
        this.setState({
          loading: false,
          status,
          fields: JSON.stringify(body.fields, null, '\t'),
        });
      } catch (error) {
        this.setState({
          error: error.message,
          loading: false,
          status: 500,
        });
      }
    });
  }

  render() {
    const { loading, esp, sender, id, fields, status, error } = this.state;

    return (
      <Auth forRoles={[Role.Superuser, Role.TestNotifications]}>
        <Nav>
          <div>
            <h1>Send a Test Email</h1>
            <Segment>
              <Dimmer active={loading}>
                <Loader />
              </Dimmer>

              <Form>
                <Message error={status !== 200}>
                  Last Result:
                  {' '}
                  {status}
                  <br />
                  {error}
                </Message>
                <Grid columns="equal">
                  <Grid.Row>
                    <Grid.Column width={2}>
                      <Dropdown
                        selection
                        options={[{ text: 'ExactTarget', value: 'et' }, { text: 'SendGrid', value: 'sg' }]}
                        defaultValue={esp}
                        onChange={this.setStateField('esp')}
                      />
                    </Grid.Column>
                    <Grid.Column width={2} textAlign="right">
                      <Dropdown
                        selection
                        allowAdditions
                        options={[{ text: 'gbpay', value: 'gbpay' }, { text: 'gbgeneral', value: 'gbgeneral' }]}
                        placeholder="Sender Profile"
                        defaultValue={sender}
                        onChange={this.setStateField('sender')}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Input
                        fluid
                        onChange={this.setStateField('id')}
                        defaultValue={id}
                        placeholder="ESP Template Id"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <TextArea
                        onChange={this.setStateField('fields')}
                        value={fields}
                        placeholder="Enter JSON fields definition"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Input
                        label="Prefill from Transaction Id"
                        action={<Button onClick={this.getTransactionId}>Fetch</Button>}
                        onChange={this.setStateField('transactionId')}
                        defaultValue={id}
                      />
                    </Grid.Column>
                    <Grid.Column textAlign="right">
                      <Button negative onClick={this.callApi}>Send Email (to you)</Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form>
            </Segment>
          </div>
        </Nav>
      </Auth>
    );
  }
}

export const Notifications = connect(({ auth }) => ({ groups: auth.groups }))(withRouter(BaseNotificationPage));
